import { render, staticRenderFns } from "./AvatarMenu.vue?vue&type=template&id=0f711b98&scoped=true"
import script from "./AvatarMenu.vue?vue&type=script&lang=js"
export * from "./AvatarMenu.vue?vue&type=script&lang=js"
import style0 from "./AvatarMenu.vue?vue&type=style&index=0&id=0f711b98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f711b98",
  null
  
)

export default component.exports